<form name="dataCollectionForm" class="collection-form tab-content" autocomplete="off">
  <ng-container *ngIf="formsConfig">
    <div *ngFor="let formConfig of formsConfig; trackBy: trackByFormId" class="data-form-content Flexbox ">
      <span class="Flexbox Flexbox__direction-rows results-pane" style="flex: 1 0 auto;width: 75%">
      <gen-dynamic-form class="collection-dynamic-form"
                        [formName]="formConfig.formId"
                        [title]="formConfig.title"
                        [subTitle]="formConfig.subTitle"
                        [disabled]="false"
                        [formData]="formData"
                        [formVertical]="formConfig.formVertical"
                        [formHalfWidth]="formConfig.formHalfWidth"
                        [formItemFullWidth]="formConfig.formItemFullWidth"
                        (formChange)="updateRelevantResource($event.updated,$event.form,formConfig.key)"

      >
      </gen-dynamic-form>
    </span>
    </div>
  </ng-container>
</form>
